import { render, staticRenderFns } from "./ChartOptions.vue?vue&type=template&id=b3cd80d4&scoped=true"
import script from "./ChartOptions.vue?vue&type=script&lang=ts"
export * from "./ChartOptions.vue?vue&type=script&lang=ts"
import style0 from "./ChartOptions.vue?vue&type=style&index=0&id=b3cd80d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cd80d4",
  null
  
)

export default component.exports